import React from 'react';
import { FinalCTA, FinalCTAContent, FinalCTAActions } from './CTA.styles';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { useNavigate } from 'react-router-dom';
const CTA = () => {
  const navigate = useNavigate();
  return (
    <FinalCTA>
      <FinalCTAContent>
        <p className="eyebrowHeader">Ready to Go Digital?</p>

        <h2>Bring Your Workplace Safety Forms Online</h2>

        <p>
          Send us the forms your company already uses and talk with our team
          about creating a digital setup that works for your workplace.
        </p>
      </FinalCTAContent>

      <FinalCTAActions>
        <PrimaryButton
          functionName={() => navigate('/contact-us')}
          span="Contact Us"
        />
      </FinalCTAActions>
    </FinalCTA>
  );
};

export default CTA;
